import type { FC, ReactElement } from "react"

import { ErrorBoundary } from "react-error-boundary"

import { ErrorHint, Loadable, Modal } from "@/3514/components"
import { EModalId } from "@/3514/store/modal"
import { type IUseTranslation, useTranslation } from "@/hooks"

import Loader from "../../elements/coaching-sessions.modal-loader.element"
import classes from "../../styles"

import ModalBody from "./coaching-sessions.modal.schedule-available.body.component"

const CoachingSessionsModalScheduleAvailableContainer: FC = (): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return (
        <Modal
            modalId={EModalId.ScheduleAvailableSessions}
            modalBodyClassName={classes.modal.scheduleAvailable.container()}
            title={t("entities.sessions.modal.scheduleAvailable.title")}
            withDisabledBodyScroll
            withHideOnEscapeClick
            withHideOnOutsideClick
            withStickyHeading
            withCloseIcon
            withPortal
        >
            <ErrorBoundary fallback={<ErrorHint isVisible />}>
                <Loadable component={ModalBody} loadingFallback={<Loader />} />
            </ErrorBoundary>
        </Modal>
    )
}

CoachingSessionsModalScheduleAvailableContainer.displayName = "CoachingSessionsScheduleAvailableModalContainer"

export default CoachingSessionsModalScheduleAvailableContainer
